module.exports = __webpack_public_path__ + "img/pointer-black.ff568fb7.svg";